(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["h2d-bogo-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('h2d-bogo-offer')) {
  customElements.define('h2d-bogo-offer', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      const templateView=this.dataset.templateView;
      if(!window.h2dBogoHistoryPatched){
        window.h2dBogoHistoryPatched=true;
        const replace=history.replaceState;
        history.replaceState=function(state,title,path){
          if(path){
            const target=new URL(path,location.href);
            if(document.querySelector('.h2d-bogo-page')&&target.pathname===location.pathname&&target.pathname.includes('/products/'))target.searchParams.set('view',templateView);
            return replace.call(this,state,title,target.href);
          }
          return replace.apply(this,arguments);
        };
      }
      this.root=this.closest('product-info');
      this.dialog=this.querySelector('dialog');
      this.strings=JSON.parse(this.querySelector('[data-bogo-strings]').textContent);
      this.onClick=(event)=>{
        if(event.target.closest('[data-open]')) { this.syncFirst(); this.updateChoices(); this.dialog.showModal(); }
        if(event.target.closest('[data-close]')) this.dialog.close();
        if(event.target.closest('[data-add]')) this.addPair();
      };
      this.addEventListener('click',this.onClick);
      this.addEventListener('change',()=>this.updateChoices());
      this.dialog?.addEventListener('close',()=>this.querySelector('[data-open]')?.focus());
      const save=this.root.querySelector('[data-bogo-save]');
      let saved=false;
      try { saved=localStorage.getItem('h2d-saved-'+this.dataset.product)==='true'; } catch {}
      const showSaved=()=>{save?.setAttribute('aria-pressed',String(saved));save?.setAttribute('aria-label',saved?this.strings.saved:this.strings.save);};
      showSaved();
      save?.addEventListener('click',()=>{saved=!saved;try{localStorage.setItem('h2d-saved-'+this.dataset.product,String(saved));}catch{}showSaved();});
      customElements.whenDefined('product-info').then(()=>{
        const build=this.root.buildRequestUrl;
        if(build&&!this.root.bogoViewPatched) {
          this.root.bogoViewPatched=true;
          this.root.buildRequestUrl=function(...args){const url=new URL(build.apply(this,args),location.origin);url.searchParams.set('view',templateView);return url.pathname+url.search;};
          const update=this.root.updateURL;
          this.root.updateURL=function(...args){update.apply(this,args);const url=new URL(location.href);url.searchParams.set('view',templateView);history.replaceState(history.state,'',url);};
        }
      });
      this.observer=new MutationObserver(records=>{
        if(records.some(record=>record.target.closest?.('variant-selects')||[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches('variant-selects')||node.querySelector('variant-selects'))))) this.syncCurrent();
      });
      this.observer.observe(this.root,{childList:true,subtree:true});
      this.syncCurrent();
      this.updateChoices();
    }
    disconnectedCallback(){this.observer?.disconnect();}
    current(){try{return JSON.parse(this.root.querySelector('variant-selects [data-selected-variant]')?.textContent||'null');}catch{return null;}}
    syncCurrent(){
      const current=this.current();
      if(!current)return;
      this.querySelector('[data-single-name]').textContent=current.public_title||current.title;
      this.querySelector('[data-single-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(current.price/100);
      const img=this.querySelector('.h2d-bogo-single-image');
      if(img){const source=current.featured_image?.src;img.removeAttribute('srcset');img.hidden=!source;if(source){img.src=source;img.alt=current.title;}else{img.removeAttribute('src');}}
      const title=current.title.toLowerCase();
      let character='';
      this.root.querySelectorAll('[data-bogo-story]').forEach(story=>{const match=title.includes(story.dataset.bogoStory.toLowerCase());story.hidden=!match;if(match)character=story.dataset.bogoStory;});
      const label=this.root.querySelector('[data-bogo-character]');
      if(label)label.textContent=character?character.toUpperCase()+' · ':'';
    }
    syncFirst(){const select=this.querySelector('[data-choice="1"]');const current=this.current();if(select&&current&&[...select.options].some(o=>o.value===String(current.id)))select.value=String(current.id);}
    updateChoices(){
      this.querySelectorAll('[data-choice]').forEach(select=>{
        const option=select.selectedOptions[0], slot=select.dataset.choice;
        const img=this.querySelector('[data-choice-image="'+slot+'"]');
        if(img){const source=option?.dataset.image;img.hidden=!source;if(source){img.src=source;img.alt=option.textContent;}else{img.removeAttribute('src');}}
        const caption=this.querySelector('[data-choice-name="'+slot+'"]');
        if(caption)caption.textContent=option?.textContent||'';
      });
      const add=this.querySelector('[data-add]');
      if(add)add.disabled=[...this.querySelectorAll('[data-choice]')].some(s=>!s.value);
    }
    async addPair(){
      const button=this.querySelector('[data-add]'), error=this.querySelector('[data-error]');
      if(button.disabled)return;
      const ids=[...this.querySelectorAll('[data-choice]')].map(s=>Number(s.value));
      if(ids.length!==2||ids.some(id=>!Number.isSafeInteger(id)||id<=0))return;
      button.disabled=true;button.textContent=this.strings.adding;error.hidden=true;
      const counts=new Map();ids.forEach(id=>counts.set(id,(counts.get(id)||0)+1));
      try {
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...counts].map(([id,quantity])=>({id,quantity}))})});
        const data=await response.json();
        if(!response.ok)throw new Error(data.description||this.strings.error);
        location.assign(this.dataset.cartUrl);
      }catch(err){error.textContent=err.message||this.strings.error;error.hidden=false;button.disabled=false;button.textContent=this.strings.add;}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["h2d-editorial-controls"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('h2d-editorial-controls'))customElements.define('h2d-editorial-controls',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const root=this.closest('product-info'),view=this.dataset.view,control=this;
if(!window.h2dBogoHistoryPatched){
window.h2dBogoHistoryPatched=true;const replace=history.replaceState;
history.replaceState=function(state,title,path){if(path){const target=new URL(path,location.href);if(root.isConnected&&target.pathname===location.pathname&&target.pathname.includes('/products/'))target.searchParams.set('view',view);return replace.call(this,state,title,target.href);}return replace.apply(this,arguments);};
}
customElements.whenDefined('product-info').then(()=>{
if(root.bogoViewPatched)return;root.bogoViewPatched=true;
const build=root.buildRequestUrl;if(build)root.buildRequestUrl=function(...args){const url=new URL(build.apply(this,args),location.origin);url.searchParams.set('view',view);return url.pathname+url.search;};
});
const save=root.querySelector('[data-bogo-save]');let saved=false;
try{saved=localStorage.getItem('h2d-saved-'+this.dataset.product)==='true';}catch{}
const display=()=>{save?.setAttribute('aria-pressed',String(saved));save?.setAttribute('aria-label',saved?control.dataset.saved:control.dataset.save);};
display();save?.addEventListener('click',()=>{saved=!saved;try{localStorage.setItem('h2d-saved-'+this.dataset.product,String(saved));}catch{}display();});
const sync=()=>{let current;try{current=JSON.parse(root.querySelector('variant-selects [data-selected-variant]')?.textContent||'null');}catch{}if(!current)return;let name='';root.querySelectorAll('[data-bogo-story]').forEach(story=>{const match=current.title.toLowerCase().includes(story.dataset.bogoStory.toLowerCase());story.hidden=!match;if(match)name=story.dataset.bogoStory;});const label=root.querySelector('[data-bogo-character]');if(label)label.textContent=name?name.toUpperCase()+' · ':'';};
this.observer=new MutationObserver(records=>{if(records.some(r=>r.target.closest?.('variant-selects')||[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('variant-selects')||n.querySelector('variant-selects')))))sync();});
this.observer.observe(root,{childList:true,subtree:true});sync();
}
disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["h2d-header-categories"] && !Shopify.designMode) return;
  try {
    (() => {
 function close(nav){nav.querySelectorAll('.h2d-menu-panel').forEach(p=>p.hidden=true);nav.querySelectorAll('.h2d-menu-toggle').forEach(b=>b.setAttribute('aria-expanded','false'));}
 document.addEventListener('click',event=>{
  const button=event.target.closest('.h2d-menu-toggle');
  document.querySelectorAll('.h2d-header-categories').forEach(nav=>{if(!nav.contains(event.target))close(nav);});
  if(!button)return;
  const nav=button.closest('.h2d-header-categories'),open=button.getAttribute('aria-expanded')==='true';
  close(nav);
  if(!open){nav.querySelector('[data-menu-panel="'+button.dataset.menuIndex+'"]').hidden=false;button.setAttribute('aria-expanded','true');}
 });
 document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const nav=event.target.closest('.h2d-header-categories');if(nav){const button=nav.querySelector('.h2d-menu-toggle[aria-expanded="true"]');close(nav);button?.focus();}});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["h2d-product-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-h2d-back]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  try {
    const referrer = new URL(document.referrer);
    if (referrer.origin === location.origin && history.length > 1) {
      event.preventDefault();
      history.back();
    }
  } catch {}
});
  } catch(e) { console.error(e); }
})();

})();
